import { useTranslation } from "@1f/react-sdk";
import Grid from "@vapor/react-material/Grid";
import Divider from "@vapor/react-material/Divider";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";
import FormControl from "@vapor/react-material/FormControl";
import FormControlLabel from "@vapor/react-material/FormControlLabel";
import RadioGroup from "@vapor/react-material/RadioGroup";
import Radio from "@vapor/react-material/Radio";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";

export const AnagraficaPepSection = ({
  currentAnagrafica,
  anagPep,
  basePoliticalRole,
  isCessato,
  isNotLastVersion,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Divider variant="standard" sx={{ pt: 2 }} />
      <ExtendedTypography variant="titleSmall" color="primary.main">
        {t("anagrafica.anagraficaForm.ppe")}
      </ExtendedTypography>
      <FormControl>
        <RadioGroup
          name="radioBtnIsPep"
          onChange={onChange}
          disabled={isCessato || isNotLastVersion}
        >
          <FormControlLabel
            value="isNotPep"
            checked={anagPep.IsNotPep}
            control={<Radio />}
            label="Non è una persona politicamente esposta"
            disabled={isCessato || isNotLastVersion}
          />
          <FormControlLabel
            value="isPep"
            checked={anagPep.IsPep}
            control={<Radio />}
            label="E' una persona politicamente esposta"
            disabled={isCessato || isNotLastVersion}
          />
          <FormControlLabel
            value="isNotPepMoreThanYear"
            checked={anagPep.IsNotPepMoreThanYear}
            control={<Radio />}
            label="Non è una persona politicamente esposta da più di un anno"
            disabled={isCessato || isNotLastVersion}
          />
        </RadioGroup>
      </FormControl>

      {anagPep.IsPep ? (
        <Grid container xs={12} sx={{ mt: 2 }}>
          <Grid item xs={6} sx={{ pr: 2 }}>
            <Autocomplete
              id="ddlPepCarica"
              label="Ruolo politico ricoperto"
              size="small"
              options={basePoliticalRole}
              onChange={onChange}
              fullWidth
              sx={{ width: "100%" }}
              defaultValue={
                basePoliticalRole.filter(
                  (role) => role === currentAnagrafica.pepRuolo
                )[0]
              }
              renderInput={(params) => (
                <TextField {...params} required label="Carica politica ricoperta" />
              )}
              readOnly={isCessato || isNotLastVersion}
            />
          </Grid>
          <Grid item xs={6} sx={{ pl: 0 }}>
            <TextField
              id="txtPepCarica"
              label="Descrizione carica politica"
              size="small"
              fullWidth
              defaultValue={currentAnagrafica.pepCarica}
              onChange={onChange}
              inputProps={{ autocomplete: "nope", maxLength: 255 }}
              readOnly={isCessato || isNotLastVersion}
            />
          </Grid>
        </Grid>
      ) : null}
    </>
  );
};
